export default __webpack_public_path__ + "static/card2-2ea32f78c8b2c36ad8ef0012395736a1.png";